/**
 * NewTicketModal — the New Ticket form in a dialog, opened from the global
 * header support button. Identical content to /support/new (shared
 * SupportTicketForm); the "Related" field is pre-populated with the exact route
 * the user pressed the button from (e.g. "/loan/123/documents") so support knows
 * where the ticket was filed.
 */
import Box from "@mui/material/Box";
import CloseRounded from "@mui/icons-material/CloseRounded";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";

import SupportTicketForm from "./SupportTicketForm";
import { T } from "./supportUi";

const NewTicketModal = ({ open, onClose, relatedRoute = "" }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <Box sx={{ p: "24px 28px 4px", position: "relative" }}>
      <IconButton
        onClick={onClose}
        size="small"
        aria-label="Close"
        sx={{ position: "absolute", top: 14, right: 14, color: T.ink500 }}
      >
        <CloseRounded sx={{ fontSize: 20 }} />
      </IconButton>
      <Box sx={{ fontSize: 21, fontWeight: 800, color: T.ink900, lineHeight: 1.2, pr: 4 }}>
        New support ticket
      </Box>
      <Box sx={{ fontSize: 13.5, color: T.ink500, mt: 0.5 }}>
        Tell us what's going on — we'll route it to the right person.
      </Box>
    </Box>
    <DialogContent sx={{ p: 0 }}>
      <SupportTicketForm
        relatedDealId={relatedRoute}
        relatedLabel={relatedRoute}
        relatedReadOnly={Boolean(relatedRoute)}
        relatedFieldLabel="Submitted from"
        relatedHelp="The specific area of the portal this issue pertains to — captured automatically from the page you're on."
        autoFocusSubject
        onCreated={() => onClose?.()}
        onCancel={() => onClose?.()}
      />
    </DialogContent>
  </Dialog>
);

export default NewTicketModal;
